import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone } from '@angular/core';
import { OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Event } from '@angular/router';
import { environment } from 'src/environments/environment';
import cloneDeep from 'lodash/cloneDeep';
import { CheckAuthToken } from 'src/app/handler/auth-check';
import { AUTHGWCONSTANTS } from './authorization/authconstatnts';
import { AppService } from './app.service';
import { BuildConfig } from 'src/app/handler/build-config';
import { Util } from './util/util';
import moment from 'moment';
import { StaticMemory } from 'src/app/handler/static_memory';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LocationSetDialogComponent } from './element-widgets/location-set-dialog/location-set-dialog.component';
import { PopupDialogComponent } from './element-widgets/popup-dialog/popup-dialog.component';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SigninComponent } from './authorization/signin/signin.component';
import gsap from 'gsap';
import { NotificationService } from './services/notification.service';
import { SpinWheelDialogComponent } from './element-widgets/spin-wheel-dialog/spin-wheel-dialog.component';
import { SpinWheelService } from './services/spin-wheel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppService],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AppComponent implements OnInit {
  buildVersion: String = environment.version + '+' + environment.versionCode;
  vHostUrl = environment.proxyApiUrl;
  currentYear = new Date().getFullYear();
  data: any = {};
  addressdata: any = null;
  shopObject: any = {};
  subCategoryArray: Array<any> = [];
  categoryArray: Array<any> = [];
  localStorageProduct: Array<any> = [];
  cashBackOfferArray: Array<any> = [];
  productObj: any = {};
  wishlistObj: any = {};
  cartItemCount: number = 0;
  cartItemPrice: number = 0;
  wishlistCount: number = 0;
  loggedIn = false;
  loading = true;
  auth = new CheckAuthToken();
  searchInput: string = '';
  profileName: string = '';
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  showHome: boolean;
  hideLayout: boolean = false;
  hideSearchBar: boolean = false;
  hideCart: boolean = false;
  name: string = '';
  selectedIndex: string = null;
  screenWidth: number = 0;
  showFilterBtn = false;
  searchResults: any[] = [];
  isSearchResultsVisible: boolean = false;
  searchList: Array<any> = [];
  currentPlaceholderIndex: number = 0;
  dynamicPlaceholder: string = '';
  private lastSearchRequestId = 0;
  errorMessage: string = '';
  isSearchLoading = false;
  hideHeaderFooter: boolean = false;
  showDeliveryAnimation: boolean = false;
  isCartOrCheckout: boolean = false;

  @ViewChild('top') topElement: ElementRef;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  @HostListener('window:scroll', [])
  onWindowScroll(): void {}
  businessProfile$ = new BehaviorSubject<any>(null);
  hasSpeechSupport = false;
  isListening = false;
  // Notification State
  showNotificationModal = false;
  currentNotification: any = null;
  private audioContext: any;
  private ringtoneInterval: any;
  private autoCloseTimer: any;

  private recognition: any;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private service: AppService,
    private activatedroute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private notificationService: NotificationService,
    private spinWheelService: SpinWheelService
  ) {
    this.localStorageProduct = JSON.parse(localStorage.getItem(BuildConfig.productArray));
    this.service.onOnlineCartReload.subscribe((response: any) => {
      if (StaticMemory.isServiceArea) {
        if (this.service.updateHeaders()) {
          this.getCarts();
        }
      } else {
        AppService.globalCartCounter = 0;
      }
    });

    this.service.onOnlineWishlistReload.subscribe((response) => {
      if (StaticMemory.isServiceArea) {
        if (this.service.updateHeaders()) {
          this.getWishlists();
        }
      } else {
        AppService.globalWishlistCounter = 0;
      }
    });

    this.service.onOfflineCartReload.subscribe((response) => {
      this.onOfflineCartReload();
    });
    this.router.events
      .pipe(filter((event: Event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.hideLayout = event.url.includes('/search-products');
        this.hideSearchBar = ['/auth/signin', '/auth/otp', '/auth/signup'].some((path) =>
          event.url.includes(path)
        );
        this.isCartOrCheckout = ['/cart', '/checkout'].some((path) => event.url.includes(path));
      });
    this.router.events
      .pipe(filter((event: Event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.hideCart = [
          '/auth/signin',
          '/auth/otp',
          '/auth/signup',
          '/my-account',
          // '/cart',
          '/checkout'
        ].some((path) => event.url.includes(path));
        this.showFilterBtn = event.url.includes('/shop');
        this.hideHeaderFooter =
          event.url.includes('/auth/signin') ||
          event.url.includes('/auth/otp') ||
          event.url.includes('/auth/signup');
      });
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined' && localStorage) {
      const hasSeenAnimation = localStorage.getItem('hasSeenDeliveryAnimation');
      if (!hasSeenAnimation) {
        this.showDeliveryAnimation = true;
        setTimeout(() => {
          this.initGsapAnimations();
        }, 100);
      }
    }
    this.screenWidth = window.innerWidth;
    const serviceArea = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.serAreaObject));
    const addressObj = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.addressObject));
    if (serviceArea) {
      StaticMemory.isServiceArea = true;
      StaticMemory.serAreaObject = serviceArea;
    }
    if (addressObj) {
      StaticMemory.addressObject = addressObj;
    }
    AppService.addressChange.subscribe((result) => {
      if (result) {
        this.addressdata = result;
      } else {
        this.addressdata = result;
      }
    });
    if (this.service.updateHeaders()) {
      this.onCheckAuth();
    }
    this.activatedroute.queryParams.subscribe((params) => {
      this.selectedIndex = params['pId'];
      this.searchInput = params.search || '';
      this.hideLayout = this.router.url.includes('/search-products');
      this.hideSearchBar = ['/auth/signin', '/auth/otp'].some((domain) =>
        this.router.url.includes(domain)
      );
      this.hideCart = ['/auth/signin', '/auth/otp', '/my-account', '/cart', '/checkout'].some(
        (domain) => this.router.url.includes(domain)
      );
      this.isCartOrCheckout = ['/cart', '/checkout'].some((path) => this.router.url.includes(path));
    });
    setTimeout(() => {
      this.loading = false;
      this.loadScripts();
      this.openSpinWheelDialog();
    }, 500);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.service.searchList$.subscribe((list) => {
      this.searchList = list;
      this.startRotatingPlaceholder();
    });

    this.initVoiceSearch();

    // Add a document click listener to unlock audio context on mobile (user interaction required)
    const unlockAudio = () => {
      if (typeof window !== 'undefined') {
        const AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext;
        if (AudioContext) {
          const ctx = new AudioContext();
          ctx.resume().then(() => {
            ctx.close();
            document.removeEventListener('click', unlockAudio);
            document.removeEventListener('touchstart', unlockAudio);
          });
        }
      }
    };
    if (typeof document !== 'undefined') {
      document.addEventListener('click', unlockAudio);
      document.addEventListener('touchstart', unlockAudio);
    }

    this.notificationService.currentMessage.subscribe((payload: any) => {
      if (payload) {
        this.ngZone.run(() => {
          const notification = payload.notification;
          if (notification) {
            this.currentNotification = notification;
            this.showNotificationModal = true;
            this.playRingtone();
            this.cdr.detectChanges();
            if (this.autoCloseTimer) {
              clearTimeout(this.autoCloseTimer);
            }
            this.autoCloseTimer = setTimeout(() => {
              this.closeNotificationModal();
            }, 3000);

            if (
              typeof window !== 'undefined' &&
              'Notification' in window &&
              (window as any).Notification.permission === 'granted'
            ) {
              try {
                const sysNotification = new (window as any).Notification(notification.title, {
                  body: notification.body,
                  icon: '/assets/icons/icon-72x72.png',
                  data: payload.data
                });
                sysNotification.onclick = () => {
                  window.focus();
                  sysNotification.close();
                };
              } catch (e) {
                console.error('System notification error', e);
              }
            }
          }
        });
      }
    });
  }

  private initVoiceSearch(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const win = window as any;
    const SpeechRecognitionCtor = win.SpeechRecognition || win.webkitSpeechRecognition;
    if (!SpeechRecognitionCtor) {
      this.hasSpeechSupport = false;
      return;
    }

    this.hasSpeechSupport = true;
    this.recognition = new SpeechRecognitionCtor();
    this.recognition.lang = 'en-IN';
    this.recognition.interimResults = false;
    this.recognition.maxAlternatives = 1;

    this.recognition.onstart = () => {
      this.ngZone.run(() => {
        this.isListening = true;
        this.cdr.detectChanges();
      });
    };

    this.recognition.onend = () => {
      this.ngZone.run(() => {
        this.isListening = false;
        this.cdr.detectChanges();
      });
    };

    this.recognition.onerror = (event: any) => {
      this.ngZone.run(() => {
        console.error('Speech recognition error:', event);
        this.isListening = false;
        this.cdr.detectChanges();
      });
    };

    this.recognition.onresult = (event: any) => {
      this.ngZone.run(() => {
        try {
          const transcript = event.results[0][0].transcript;
          this.searchInput = transcript;
          this.cdr.detectChanges();
          this.onSearch();
        } catch (e) {
          console.error('Error processing speech result:', e);
        }
      });
    };
  }

  onVoiceSearchClick(): void {
    if (!this.recognition) {
      return;
    }
    try {
      if (this.isListening) {
        this.recognition.stop();
      } else {
        this.recognition.start();
      }
    } catch (e) {
      console.error('Error starting/stopping recognition:', e);
    }
  }

  onGetStarted(): void {
    if (this.autoDismissTimer) {
      this.autoDismissTimer.kill();
    }

    gsap.to('.freshness-splash-overlay', {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        this.showDeliveryAnimation = false;
        if (typeof window !== 'undefined' && localStorage) {
          localStorage.setItem('hasSeenDeliveryAnimation', 'true');
        }
      }
    });
  }

  private autoDismissTimer: any;

  private initGsapAnimations(): void {
    const tl = gsap.timeline();

    tl.from('.freshness-splash-overlay', {
      opacity: 0,
      duration: 0.5,
      ease: 'power2.out'
    })
      .from(
        '.icon-wrapper',
        {
          scale: 0,
          opacity: 0,
          duration: 1.2,
          ease: 'elastic.out(1, 0.5)'
        },
        '-=0.2'
      )
      .from(
        '.splash-headline',
        {
          y: 30,
          opacity: 0,
          duration: 0.8,
          ease: 'back.out(1.2)'
        },
        '-=0.8'
      )
      .from(
        '.splash-subtext',
        {
          y: 20,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out'
        },
        '-=0.6'
      )
      .from(
        '.splash-cta',
        {
          scale: 0.8,
          opacity: 0,
          duration: 0.6,
          ease: 'back.out(1.5)'
        },
        '-=0.4'
      );

    gsap.to('.splash-cta', {
      scale: 1.05,
      duration: 0.8,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut',
      delay: 2
    });

    this.autoDismissTimer = gsap.delayedCall(5, () => {
      this.onGetStarted();
    });
  }

  // @HostListener('window:resize')
  @HostListener('window:resize')
  onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  onCheckAuth(): void {
    const guestCheck = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);
    const authCheck = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);

    if (authCheck && authCheck.length) {
      CheckAuthToken.loggedIn = true;
      this.loggedIn = true;
      this.notificationService.requestPermission();
      this.notificationService.receiveMessage();
      this.getCashBackOffers();
      this.getProfile();
      this.getBusinessProfile();
      this.getAddress();
      this.getParentCategories();
    } else {
      CheckAuthToken.loggedIn = false;
      this.loggedIn = false;
      const cartCount = JSON.parse(localStorage.getItem(BuildConfig.cartCount));
      const wishCount = JSON.parse(localStorage.getItem(BuildConfig.wishCount));
      if (cartCount) {
        this.cartItemCount = cartCount;
      }
      if (wishCount) {
        this.wishlistCount = wishCount;
      }
      if (!guestCheck) {
        this.getGuestToken();
      } else {
        this.getBusinessProfile();
        this.getParentCategories();
      }
    }
  }

  onChangeAddress(): void {
    if (CheckAuthToken.loggedIn) {
      this.service.signinState$.next('open');
      if (StaticMemory.isServiceArea) {
        const data = {
          type: 1,
          location_message: ''
        };
        this.openLocationSetDialog(data);
      } else {
        this.openAlertDialog();
      }
      this.service.signinState$.next('close');
    } else {
      const data = {
        type: 2,
        location_message: ''
      };
      this.openLocationSetDialog(data);
    }
  }

  getGuestToken(): void {
    this.service.getGuestToken().subscribe(
      (success) => {
        if (success.status && success.result && success.result) {
          localStorage.setItem(AUTHGWCONSTANTS.guestAuth, success.result[0]);
          if (this.service.updateHeaders()) {
            this.getBusinessProfile();
            this.getParentCategories();
          }
        }
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  getAddress(): void {
    this.service.getAddress().subscribe(
      (success) => {
        if (success.status && success.result && success.result) {
          if (success.result.length === 1) {
            localStorage.setItem(AUTHGWCONSTANTS.addressObject, JSON.stringify(success.result[0]));
            StaticMemory.addressObject = success.result[0];
            this.addressdata = success.result[0];
          } else {
            for (let i = 0; i < success.result.length; i++) {
              if (success.result[i].default) {
                localStorage.setItem(
                  AUTHGWCONSTANTS.addressObject,
                  JSON.stringify(success.result[i])
                );
                StaticMemory.addressObject = success.result[i];
                this.addressdata = success.result[i];
              }
            }
          }
          this.getServiceArea();
        } else {
          const data = {
            type: 1,
            location_message: success.message
          };
          this.openLocationSetDialog(data);
        }
      },
      (error) => {}
    );
  }

  getServiceArea(): void {
    const value = JSON.parse(localStorage.getItem(AUTHGWCONSTANTS.addressObject));
    const urlParams: any = {
      latitude: value.latitude,
      longitude: value.longitude
    };
    if (value.location) {
      urlParams.latitude = value.location['co-ordinates'][1];
      urlParams.longitude = value.location['co-ordinates'][0];
    }
    this.service.getServiceArea(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          localStorage.setItem(AUTHGWCONSTANTS.serAreaObject, JSON.stringify(success.result[0]));
          StaticMemory.serAreaObject = success.result[0];
          StaticMemory.isServiceArea = true;
          if (this.localStorageProduct && this.localStorageProduct.length) {
            for (let i = 0; i < this.localStorageProduct.length; i++) {
              this.productObj = cloneDeep({});
              this.productObj.isOrdered = false;
              this.productObj.subProductId = this.localStorageProduct[i].subproductId;
              this.productObj.selectedQuantity = this.localStorageProduct[i].selectedQuantity;
              // this.productObj.cashback = this.localStorageProduct[i].cashBackAmount;
              this.productObj.cashback = 0;

              const currentOffer = this.getSmallestInvoiceOffer(this.localStorageProduct[i].price);

              if (this.localStorageProduct[i].cashBack && !currentOffer) {
                if (this.localStorageProduct[i].discountType === 'CENT') {
                  this.productObj.cashback =
                    (this.localStorageProduct[i].price / 100) *
                    this.localStorageProduct[i].discount;
                  this.productObj.cashback *= this.productObj.selectedQuantity;
                  if (this.localStorageProduct[i].discountUpto) {
                    if (this.productObj.cashback >= this.localStorageProduct[i].discountUpto) {
                      this.productObj.cashback = this.localStorageProduct[i].discountUpto;
                    }
                  }
                } else {
                  this.productObj.cashback =
                    this.localStorageProduct[i].discount * this.productObj.selectedQuantity;
                }
              }
              if (StaticMemory.isServiceArea) {
                this.postProductInCart();
              }
            }
          }
          if (this.service.updateHeaders()) {
            if (StaticMemory.isServiceArea) {
              this.getCarts();
              this.getWishlists();
            }
          }
        } else {
          localStorage.removeItem(AUTHGWCONSTANTS.serAreaObject);
          if (!this.addressdata) {
            const data = {
              type: 1,
              location_message: success.message
            };
            this.openLocationSetDialog(data);
          }
        }
      },
      (error) => {}
    );
  }

  getCashBackOffers(): void {
    const urlParams: any = {
      type: 3,
      channel: 'NECOM',
      warehouseId: StaticMemory.serAreaObject?.warehouseId
    };
    this.service.getOffers(urlParams).subscribe((success) => {
      try {
        if (success.status && success.result && success.result.length) {
          this.cashBackOfferArray = success.result;
        }
      } catch (error: any) {}
    });
  }

  getSmallestInvoiceOffer(gTotal: any) {
    const currentDate = parseInt(moment(Date.now()).format('YYYYMMDD'));
    const idx = this.cashBackOfferArray
      .filter(
        (resp: any) => resp.validFromXDate <= currentDate && currentDate <= resp.validTillXDate
      )
      .sort((a: any, b: any) => a.invoiceValue - b.invoiceValue);
    const { currentOffer } = StaticMemory.onCashBackOfferCalculation(idx, gTotal);
    return currentOffer;
  }

  onOfflineCartReload(): void {
    let cartCounter = 0;
    let cartPrice = 0;
    const value = JSON.parse(localStorage.getItem(BuildConfig.productArray));
    if (value) {
      for (let i = 0; i < value.length; i++) {
        const qty = value[i].selectedQuantity ?? 0;
        cartCounter += value[i].selectedQuantity;
        cartPrice += value[i].price * qty;
      }
    }
    this.cartItemCount = cartCounter;
    this.cartItemPrice = cartPrice;
  }

  getParentCategories(): void {
    this.service.getParentCategories().subscribe((success) => {
      if (success.status && success.result && success.result.length) {
        success.result.forEach((item: any) => {
          this.categoryArray.push(item);
        });
        this.subCategoryArray = success.result[0].subCategoriesInfo;

        const subCatNames = this.subCategoryArray.map((sub: any) => sub.categoryName);
        this.searchList = [...new Set(subCatNames)];
        if (!this.searchList.length) {
          this.searchList = ['Cadbury Dairy Milk'];
        }
        this.startRotatingPlaceholder();

        this.activatedroute.queryParams.subscribe((paramsOrg) => {
          const catId = paramsOrg.catId;
          const selectedCategory = this.subCategoryArray.find((cat) => cat._id === catId);
          if (!selectedCategory) {
            this.shopObject.selectCategoryType = this.categoryArray[0]._id;
          }
        });
      }
    });
  }

  getProducts(): void {
    const currentRequestId = ++this.lastSearchRequestId;
    this.errorMessage = '';

    const urlParams: any = {
      limit: 10,
      skip: 0,
      priceLower: null,
      priceUpper: null,
      searchWith: this.searchInput,
      categoryId: null,
      channels: JSON.stringify(['NECOM']),
      serviceAreaId: StaticMemory.serAreaObject?._id,
      warehouseId: StaticMemory.serAreaObject?.warehouseId
    };

    if (this.router.url.includes('/search-products')) {
      this.isSearchLoading = true;
      this.isSearchResultsVisible = true;
    } else {
      this.isSearchResultsVisible = false;
    }

    this.service.getProducts(urlParams).subscribe((success) => {
      if (currentRequestId !== this.lastSearchRequestId) return;
      this.isSearchLoading = false;

      if (success.status && success.result) {
        const value = cloneDeep(success.result);

        value.forEach((v: any) => {
          if (v.productImages && v.productImages.length && v.productImages[0].link) {
            v.imageLink = v.productImages[0].link;
          } else if (v.images?.length && v.images[0]?.link) {
            v.imageLink = v.images[0].link;
          } else {
            v.imageLink = environment.placeholder;
            v.images = [{ link: environment.placeholder }];
          }
        });

        this.searchResults = value;
        if (!this.router.url.includes('/search-products')) {
          this.isSearchResultsVisible = false;
        }
      } else {
        this.searchResults = [];
        this.errorMessage = success.message || 'No products found.';
        if (!this.router.url.includes('/search-products')) {
          this.isSearchResultsVisible = false;
        }
      }
    });
  }

  startRotatingPlaceholder() {
    if (!this.searchList || !this.searchList.length) return;
    this.dynamicPlaceholder = `Search '${this.searchList[0]}'`;
    setInterval(() => {
      this.currentPlaceholderIndex = (this.currentPlaceholderIndex + 1) % this.searchList.length;
      const item = this.searchList[this.currentPlaceholderIndex];
      this.dynamicPlaceholder = `Search '${item}'`;
    }, 15000);
  }

  updateQueryParam(pCat: string, cCat: string): void {
    this.selectedIndex = pCat;
    let updatedUrl = Util.replaceURLParameter(this.router.url, 'pId', pCat);
    updatedUrl = Util.replaceURLParameter(updatedUrl, 'catId', cCat);
    Util.changeURLWithoutReloadWithRouter(this.router, updatedUrl);
    const queryParams = { pId: pCat, catId: cCat };
    this.router.navigate(['/shop'], { queryParams });
  }

  onSearch(): void {
    this.router.navigate(['/shop'], { queryParams: { search: this.searchInput } }).then(() => {
      this.isSearchResultsVisible = false;
      this.searchResults = [];
      this.scrollToTop();
    });
  }

  onSearchKeyup(value: string): void {
    if (value.length > 1) {
      this.getProducts();

      if (this.router.url.includes('/search-products')) {
        this.isSearchResultsVisible = true;
      } else {
        this.isSearchResultsVisible = false;
        this.searchResults = [];
      }
    } else {
      this.searchResults = [];
      this.isSearchResultsVisible = false;
    }
  }

  onSelectProduct(value: any): void {
    this.searchInput = value.productName;
    this.onSearch();
  }

  onClickSearchInput(): void {
    this.router
      .navigate(['/search-products'], { queryParams: { search: this.searchInput } })
      .then(() => {
        this.scrollToTop();
        this.hideLayout = true;
      });
  }

  onPriceFilter(): void {
    this.service.triggerPriceFilter();
  }

  onKeyUpSearchClear(filterValue: string): void {
    if (!filterValue) {
      if (window.location.href.includes('/shop')) {
        this.router.navigate(['/shop'], { queryParams: { search: this.searchInput } }).then(() => {
          this.scrollToTop();
        });
      }
    }
  }

  onSearchClear(): void {
    this.searchInput = '';
    this.searchResults = [];
    Util.changeURLWithoutReloadWithRouter(
      this.router,
      Util.replaceURLParameter(this.router.url, 'search', '')
    );
  }

  onCloseMenu(): void {
    document.getElementById('close-menu').click();
  }

  getBusinessProfile(): void {
    this.service.getBusinessProfile().subscribe((success) => {
      if (success.status && success.result.length) {
        this.data = success.result[0];
        StaticMemory.businessProfileObject = success.result[0];
        this.businessProfile$.next(this.data);
        this.primaryColor = this.data.primaryColor;
        this.secondaryColor = this.data.secondaryColor;
        this.tertiaryColor = this.data.tertiaryColor;
        this.showHome = this.data.showHome;
        if (this.data?.systemSettings && Object.keys(this.data?.systemSettings).length) {
          const idx = this.data?.systemSettings;
          if (idx.cod !== undefined || idx.cod !== null) {
            this.data.cod = idx.cod;
          }
        }
        this.data.primaryLogoLink = '';
        if (this.data.logo && this.data.logo.length) {
          this.data.primaryLogoLink = this.data.logo[0]?.linkMd;
        }
        if (this.data.footerLogo && this.data.footerLogo.length) {
          this.data.footerLogoLink = this.data.footerLogo[0].linkMd;
        }
        if (this.data.secondaryLogo && this.data.secondaryLogo.length) {
          this.data.secondaryLogoLink = this.data.secondaryLogo[0].linkMd;
        }

        if (this.data.fevicon && this.data.fevicon.length) {
          this.data.favIcon =
            environment.proxyApiUrl +
            '/uploads/' +
            this.data._id +
            '/entity_fevicon/' +
            this.data._id +
            '/' +
            this.data.fevicon[0].time +
            this.data.fevicon[0].mimeType;
        }
        this.favIcon.href = this.data.favIcon;
        this.data.lat_text = 0;
        if (this.data.location) {
          const value = this.data.location.coordinates;
          this.data.lat_text = value[0];
        }
        this.data.long_text = 0;
        if (this.data.location) {
          const value = this.data.location.coordinates;
          this.data.long_text = value[1];
        }
      }
    });
  }

  onMapInfo(lat: number, long: number): void {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${long}`;
    window.open(googleMapsUrl, '_blank');
  }

  getProfile(): void {
    this.service.getProfile().subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          StaticMemory.profileDetails = success.result[0];
          localStorage.setItem(
            AUTHGWCONSTANTS.profile,
            JSON.stringify(StaticMemory.profileDetails)
          );
          this.profileName = StaticMemory.profileDetails.firstName;
        }
      },
      (error: any) => {
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/']);
      }
    );
  }

  getCarts(): void {
    const urlParams: any = {
      serviceAreaId: StaticMemory.serAreaObject?._id,
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
      channel: environment.defaultChannel
    };
    let vCartCounter = 0;
    let vCartPrice = 0;
    this.service.getCarts(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          const result = success.result;
          for (const idx of result) {
            const qty = idx.selectedQuantity ?? 0;
            vCartCounter += idx.selectedQuantity;
            vCartPrice += idx.subProductInfo?.priceInfo?.price * qty;
          }
        }
        this.cartItemCount = vCartCounter;
        this.cartItemPrice = vCartPrice;
        AppService.globalCartCounter = this.cartItemCount;
        AppService.globalCartPrice = this.cartItemPrice;
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.cartItemCount = vCartCounter;
        this.cartItemPrice = vCartPrice;
        AppService.globalCartCounter = this.cartItemCount;
        AppService.globalCartPrice = this.cartItemPrice;
      }
    );
  }

  postProductInCart(): void {
    this.productObj.serviceAreaId = StaticMemory.serAreaObject?._id;
    this.productObj.warehouseId = StaticMemory.serAreaObject?.warehouseId;
    this.productObj.channel = environment.defaultChannel;
    this.service.postProductInCart(this.productObj).subscribe(
      (success) => {
        for (let i = 0; i < this.localStorageProduct.length; i++) {
          if (this.productObj.subProductId === this.localStorageProduct[i].subproductId) {
            this.localStorageProduct.splice(this.localStorageProduct[i], 1);
          }
        }
        if (!this.localStorageProduct || !this.localStorageProduct.length) {
          localStorage.removeItem(BuildConfig.cartCount);
          localStorage.removeItem(BuildConfig.productArray);
          if (this.service.updateHeaders()) {
            this.getCarts();
          }
        }
      },
      (error: any) => {
        for (let i = 0; i < this.localStorageProduct.length; i++) {
          if (this.productObj.subProductId === this.localStorageProduct[i].subproductId) {
            this.localStorageProduct.splice(this.localStorageProduct[i], 1);
          }
        }
        if (!this.localStorageProduct || !this.localStorageProduct.length) {
          localStorage.removeItem(BuildConfig.cartCount);
          localStorage.removeItem(BuildConfig.productArray);
          if (this.service.updateHeaders()) {
            this.getCarts();
          }
        }
      }
    );
  }

  getWishlists(): void {
    const urlParams: any = {
      warehouseId: StaticMemory.serAreaObject?.warehouseId
    };
    let wishCounter = 0;
    this.service.getWishlists(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          wishCounter = success.result.length;
        }
        this.wishlistCount = wishCounter;
        AppService.globalWishlistCounter = this.wishlistCount;
      },
      (error: any) => {
        this.wishlistCount = wishCounter;
        AppService.globalCartCounter = this.wishlistCount;
      }
    );
  }

  onSignin(): void {
    sessionStorage.removeItem('sign-object');
    if (this.screenWidth > 774) {
      this.service.signinState$.next('open');
      const dialogRef = this.dialog.open(SigninComponent, {
        panelClass: 'signin-dialog',
        autoFocus: false,
        disableClose: false,
        width: '480px',
        maxWidth: '90vw'
      });
      dialogRef.afterClosed().subscribe(() => {
        this.service.signinState$.next('close');
        this.onCheckAuth();
      });

      return;
    }

    this.router.navigate(['/auth/signin']).then(() => {
      this.scrollToTop();
      this.hideCart = true;
      this.hideSearchBar = true;
    });
  }

  onSignout(): void {
    localStorage.clear();
    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
    this.onCheckAuth();
  }

  myAccount(): void {
    this.router.navigate(['/my-account']).then(() => {
      this.scrollToTop();
      this.hideCart = true;
      this.hideSearchBar = false;
    });
  }

  onGoToCart(): void {
    this.router.navigate(['/checkout']).then(() => {
      this.scrollToTop();
      this.hideCart = true;
    });
  }

  onCheckoutClick(): void {
    if (CheckAuthToken.loggedIn) {
      if (StaticMemory.isServiceArea) {
        this.router.navigate(['/checkout']).then(() => {
          this.scrollToTop();
          this.hideCart = true;
        });
      } else {
        this.openAlertDialog();
      }
    } else {
      this.openPopupDialog();
    }
  }

  onClickWishlist(): void {
    this.router.navigate(['/wishlist']).then(() => {
      this.scrollToTop();
    });
  }

  loadScripts(): void {
    const dynamicScripts = ['../assets/js/main.js'];
    for (let i = 0; i < dynamicScripts.length; i++) {
      if (!document.querySelector(`script[src="${dynamicScripts[i]}"]`)) {
        const node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  openAlertDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '450px';
    dialogConfig.data = { title: 'Your address is not serviceable. Please update your address.' };
    const dialogRef = this.dialog.open(PopupDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const data = {
          type: 1,
          location_message: ''
        };
        this.openLocationSetDialog(data);
      }
    });
  }

  openPopupDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '450px';
    dialogConfig.data = { title: 'Sign-In / Sign Up to continue.' };
    const dialogRef = this.dialog.open(PopupDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.router.navigate(['auth/signin']);
        this.onSignin();
      }
    });
  }

  openLocationSetDialog(data: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    if (this.screenWidth >= 700) {
      dialogConfig.panelClass = ['dialog-class'];
      dialogConfig.height = 'auto';
      dialogConfig.width = '760px';
    } else {
      dialogConfig.panelClass = ['full-screen-dialog'];
      dialogConfig.height = 'calc(100%)';
      dialogConfig.width = 'calc(100%)';
      dialogConfig.maxWidth = '100%';
      dialogConfig.maxHeight = '100%';
    }
    dialogConfig.data = data;
    this.dialog.open(LocationSetDialogComponent, dialogConfig);
  }

  playNotificationSound(): void {
    this.playRingtone();
  }

  playRingtone(): void {
    if (typeof window !== 'undefined') {
      const AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (!AudioContext) return;

      this.stopRingtone();

      this.audioContext = new AudioContext();
      const playPulse = () => {
        if (!this.audioContext) return;
        const osc = this.audioContext.createOscillator();
        const gain = this.audioContext.createGain();

        osc.connect(gain);
        gain.connect(this.audioContext.destination);

        osc.type = 'square';
        osc.frequency.setValueAtTime(440, this.audioContext.currentTime);
        osc.frequency.setValueAtTime(480, this.audioContext.currentTime + 0.1); // Modulation

        gain.gain.setValueAtTime(0.1, this.audioContext.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.4);

        osc.start();
        osc.stop(this.audioContext.currentTime + 0.4);
      };

      // Play pattern
      let counter = 0;
      this.ringtoneInterval = setInterval(() => {
        if (counter % 4 === 0 || counter % 4 === 1) {
          // Play twice then pause
          playPulse();
        }
        counter++;
      }, 500); // Check every 500ms
      playPulse(); // Start immediately
      counter++;
    }
  }

  stopRingtone(): void {
    if (this.ringtoneInterval) {
      clearInterval(this.ringtoneInterval);
      this.ringtoneInterval = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }

  closeNotificationModal(): void {
    this.showNotificationModal = false;
    this.currentNotification = null;
    this.stopRingtone();
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  viewNotification(): void {
    this.closeNotificationModal();
    this.router.navigate(['/orders']);
  }

  openSpinWheelDialog(): void {
    if (!this.loggedIn) {
      return;
    }
    const warehouseId = StaticMemory.serAreaObject?.warehouseId || '';
    this.spinWheelService.getActiveCampaigns(warehouseId).subscribe({
      next: (res) => {
        if (res && res.status && res.result && res.result.length > 0) {
          const activeCampaign = res.result[0];
          if (
            !activeCampaign.used &&
            activeCampaign.sliceInfo &&
            activeCampaign.sliceInfo.length >= 3
          ) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.panelClass = 'spin-wheel-dialog-panel';
            dialogConfig.width = '480px';
            dialogConfig.maxWidth = '95vw';
            dialogConfig.data = {
              campaign: activeCampaign,
              warehouseId: warehouseId
            };
            this.dialog.open(SpinWheelDialogComponent, dialogConfig);
          }
        }
      },
      error: () => {}
    });
  }
}
